import React, { Component } from "react"

import { 
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    TextField,
} from "@material-ui/core"

/**
 * name
 * 
 * onCreatePurchaseClick(purchase)
 * onCancelClick
 */

class CreatePurchaseDialog extends Component {

    constructor(props) {
        
        super(props)
        
        this.state = {
            dialog: undefined,
            name: this.props.name ? this.props.name : "",
        }

    }

    readyToAdd() {
        if (this.state.name === "") {
            return false
        }
        return true
    }

    render() {

        if (this.state.dialog) {
            return this.state.dialog
        }

        return <Dialog
            open = {true}
            fullWidth = {true}        
        >

            <DialogTitle>
				Создать закупку
			</DialogTitle>

            <DialogContent style = {{display: "flex", flexDirection: "column"}}>
                
                <TextField
					value = {this.state.name}
					label = "Название закупки"
					margin = "normal"
					onChange = {e => {
						e.preventDefault()
						this.setState({name: e.target.value})
					}}                    
                />

            </DialogContent>

            <DialogActions>

                <Button
                    disabled = {!this.readyToAdd()}
                    onClick = {e => {
                        e.stopPropagation()
                        if (typeof this.props.onCreatePurchaseClick === "function") {
                            this.props.onCreatePurchaseClick({
                                name: this.state.name,
                                attachments: [],
                            })
                        }
                    }}
                >Создать</Button>

                <Button
					onClick = {e => {
						e.stopPropagation()
						if (typeof this.props.onCancelClick === "function") {
							this.props.onCancelClick()
						}
					}}
				>Отмена</Button>

            </DialogActions>

        </Dialog>

    }

}

export default CreatePurchaseDialog